
export function Home() {  
  return (
    <div>
      {/* Conteúdo da página Home */}      
    </div>
  );
}